module.exports = __webpack_public_path__ + "static/media/BuckN'Flax Cookies 100g.c7f6d1d3.jpg";